import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { UNREAD_QK } from './use-comunicado-mutations';
import { useAuth } from './use-auth';

export function useUnreadComunicados(): { count: number } {
  const { isAuthenticated } = useAuth();
  const { data } = useQuery({
    queryKey: UNREAD_QK,
    queryFn: () =>
      pb.send<{ count: number }>('/api/comunicados/unread-count', {
        method: 'GET',
      }),
    enabled: isAuthenticated,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
  return { count: data?.count ?? 0 };
}
